import * as React from 'react'

import styled from 'styled-components'
import { animated, config, useSpring } from 'react-spring'
import { Search } from '@geist-ui/react-icons'
import { useMediaQuery } from '@material-ui/core'
import { useSearchBox } from 'react-instantsearch-hooks-web'
import SearchResults from '../search/SearchResults'
import { useAtom } from 'jotai'
import { rwMobileSearchAtom } from '../../atoms/Notifications'

const OuterDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  margin-right: 15px;

  @media (min-width: 62em) {
    flex-grow: 1;
    margin-right: 0;
    margin: 0 auto;
    margin-left: 15px;
    height: 100%;
    /* max-width: calc(750px + 16px); */
  }
`

const InnerDiv = styled(animated.div)`
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 50%;
  /* background: rgba(0, 0, 0, 0.3); */
  border-width: 1px;
  border-color: #aaa;
  border-style: solid;
  padding: 8px;
  cursor: text;

  @media (min-width: 62em) {
    width: calc(100% - 16px);
    border-radius: 10px;
    /* max-width: 750px; */
  }
`

const SearchInput = styled.input`
  border-style: none;
  border-color: none;
  width: 100%;
  background-color: none;
  background: none;
  color: white;
  margin: 0 5px;
  font-weight: 500;
  height: 100%;
  -moz-appearance: textfield;
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &:focus {
    outline: none;
  }

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #aaa;
    opacity: 1; /* Firefox */
    font-weight: 400;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #aaa;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #aaa;
  }
`

const Menu = styled(animated.div)<{ visible: boolean }>`
  position: absolute;
  z-index: 1002;
  top: calc(100% + 8px);
  background: linear-gradient(rgb(35, 35, 35), rgb(20, 20, 20));
  border-width: 1px;
  border-color: #333;
  border-style: solid;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0px 15px 25px rgba(255, 255, 255, 0.052);
  pointer-events: ${(props) => (props.visible ? 'all' : 'none')};
  width: calc(100% - 30px);
  height: fit-content;
  /* max-width: 750px; */

  :focus,
  *:focus {
    outline: none;
  }
`

const SearchBar = (): JSX.Element => {
  const isMobile = useMediaQuery('(max-width: 62em)')
  const [query, setQuery] = React.useState('')
  const { refine } = useSearchBox()
  const [visible, setVisible] = React.useState(false)
  const [, setOpen] = useAtom(rwMobileSearchAtom)

  const menuOpenState = useSpring({
    opacity: visible ? 1 : 0,
    config: config.gentle,
  })

  return (
    <OuterDiv
      id="search-menu"
      tabIndex={!isMobile ? 0 : undefined}
      onClick={isMobile ? () => setOpen(true) : undefined}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
    >
      <InnerDiv>
        <Search size={25} />
        {!isMobile && (
          <SearchInput
            placeholder="Search Creators, Collectors, and Videos"
            value={query}
            onChange={(e) => {
              setQuery(e.target.value)
              refine(e.target.value)
            }}
          />
        )}
      </InnerDiv>
      {!isMobile && (
        <Menu visible={visible} style={menuOpenState}>
          <SearchResults />
        </Menu>
      )}
    </OuterDiv>
  )
}

export default SearchBar
